import { tailwindConfig as config } from '@/style/config';
/**
 * breakpoint 取得(数値)
 */
export const getScreenValueOfNumber = (key) => {
    const regex = 'px';
    const value = config.theme.screens[key].replace(new RegExp(`${regex}$`), '');
    return parseInt(value, 10);
};
